import React from "react";
import Game from "./Game";
import {prepareInfobox, shuffle, domain} from "./utils";
import Question from "./Question";


class Placement extends Game {
  GAME_NAME = 'placement';
  MAP = 'satellite';


  constructor(props) {
    super(props);
    this.state = {...this.state, points: [], question: null, questions: []};
  }

  static extractData(polygons, solved) {
    return polygons.map(polygon => {
      return {
        id: polygon.id,
        isSolved: false,
        isChecking: false,
        infobox: {...prepareInfobox(polygon.infobox), marker: polygon.point},
        draggable: true,
        point: polygon.point,
      }
    }).concat(solved.map(region => {
      return {
        id: region.id,
        isSolved: true,
        isChecking: false,
        infobox: {...prepareInfobox(region.infobox), marker: region.point, loaded: true},
        draggable: false,
        point: region.point,
      }
    })).sort((one, another) => {
      return one.infobox.name > another.infobox.name ? 1 : -1
    });
  }

  mainItems() {
    return this.state.points;
  }

  static prepareQuestions(questions) {
    return shuffle(questions
      .map(question => {
        let result = {id: question.id};
        result['name'] = question.infobox.name;
        return result;
    }));
  }

  changePointState(data, current) {
    let points = this.state.points.map((polygon) => {
      if (polygon.id === data.id) {
        return {
          draggable: false,
          id: data.id,
          isSolved: data.type === 'PLACEMENT_CHECK_SUCCESS',
          isChecking: false,
          infobox: {...data.infobox, loaded: true, marker: data.point},
          point: data.point,
        };
      }
      return polygon;
    });
    let questions = this.state.questions.filter(element => {return element.id !== data.id});
    let index = current === null ? this.state.question % questions.length : questions.findIndex(item => item.id === current.id);
    if (index === -1) {
      index = this.state.question % questions.length;
    }
    let infobox = current === null ? {...data.infobox, marker: data.point} : this.state.infobox;
    this.setState({...this.state, points: points, infobox: infobox, questions: questions, question: index}, () => {
      if (this.state.points.length > 0 && this.state.points.filter(el => el.isSolved === false).length === 0) {
        let time = new Date(Date.now() - this.state.startTime);
        this.showCongratulation(time.toLocaleTimeString('ru-RU', {timeZone: 'UTC'}));
      }
    });
  }

  dispatchMessage = (event) => {
    let data = JSON.parse(event.data);
    switch(data.type) {
      case 'PLACEMENT_CHECK_SUCCESS':
      case 'PLACEMENT_GIVEUP_DONE':
        this.changePointState({...data, infobox: prepareInfobox(data.infobox)}, null);
        break;
      case 'PLACEMENT_FOUND':
        this.changePointState({...data, infobox: prepareInfobox(data.infobox)}, this.state.questions[this.state.question]);
        break;
    }
  };

  loadData = () => {
    fetch(`${domain("http")}/placement/${this.props.slug}/questions/`)
      .then(response => response.json())
      .then(data => {
        let regions = Placement.extractData(data.questions, data.solved);
        this.startGame({points: regions, questions: Placement.prepareQuestions(data.questions), question: 0});
      })
      .catch(response => {
        this.setState({...this.state, isLoaded: false})
      });
  };

  removeChecking = id => {
    let points = this.state.points.map(item => {
      if (item.id === id) {
        item.isChecking = false;
      }
      return {...item};
    });
    this.setState({...this.state, points: points});
  };

  onPolygonClick = (polygon) => {
    let location = this.state.points.find(x => x.id === polygon.id);
    if (location.infobox.loaded) {
      this.setState({...this.state, infobox: location.infobox, showInfobox: true});
    } else {
      let question = this.state.questions[this.state.question];
      if (question) {
        let points = this.state.points.map(item => {
          if (item.id === location.id) {
            item.isChecking = true;
          }
          return {...item};
        });
        this.setState({...this.state, points: points}, () => {
          this.wsSend({type: 'PLACEMENT_CHECK', point: location.point, id: question.id});
          setTimeout(() => this.removeChecking(location.id), 1500);
        });
      }
    }
  };

  giveUp = () => {
    this.wsSend({type: 'PLACEMENT_GIVEUP', id: this.state.questions[this.state.question].id});
  };

  onNext = () => {
    this.setState({...this.state, question: (this.state.question + 1) % this.state.questions.length});
  };

  onPrevious = () => {
    let index = this.state.question - 1;
    this.setState({...this.state, question: index < 0 ? this.state.questions.length - 1 : index});
  };

  renderQuestion() {
    return <Question giveUp={this.giveUp} question={this.state.question} questions={this.state.questions}
                         onNext={this.onNext} onPrevious={this.onPrevious}/>;
  }
}


export default Placement;
